import { cn } from "@/lib/utils";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";

type DatePickerProps<T> = {
  value: Date | string | null | undefined;
  setMidnight?: boolean;
  onChange: (value: Date | null) => void;
  className?: string;
  showTime?: boolean;
};



export function DatePickerInput<T>({
  value,
  setMidnight = false,
  onChange,
  className = "",
  showTime = false
}: DatePickerProps<T>) {
  const selectedDate = (() => {
    if (value == null) return null;
    if (value instanceof Date) return Number.isNaN(value.getTime()) ? null : value;
    const parsed = new Date(value);
    return Number.isNaN(parsed.getTime()) ? null : parsed;
  })();

  return (
    <DatePicker
       selected={selectedDate}
        onChange={(date: Date | null) => {
          if (date) {
            if (showTime) {
              onChange(date);
            } else {
              const cleaned = new Date(date.getFullYear(), date.getMonth(), date.getDate());
              if (setMidnight)
                cleaned.setHours(23, 59, 59, 0);
              onChange(cleaned);
            }
          } else {
            onChange(null);
          }

        }}
        showTimeSelect={showTime??false}
        dateFormat={showTime ? "dd/MM/yyyy HH:mm" : "dd/MM/yyyy"}
        className={cn(
          "flex h-9 w-full rounded-md border border-input bg-transparent px-3 py-1 text-base shadow-sm transition-colors file:border-0 file:bg-transparent file:text-sm file:font-medium file:text-foreground placeholder:text-muted-foreground focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-ring disabled:cursor-not-allowed disabled:opacity-50 md:text-sm",
          className
        )}
       
      />
  );
}

